// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"e31decdf","453":"1bd1e97a","591":"9a89175f","680":"43d4af2f"}[chunkId] + ".chunk.js";
};